import { ReportConfig } from '../../dtos/interfaces/report-config';
import {
    SorterReturnsSummaryReportRowDto
} from "../../../services/dtos/reports/sorter/sorter-returns-summary-report-row.dto";
import moment = require('moment');
import { Period } from '../../../services/dtos/enums/period.enum'

function toRecord(d: SorterReturnsSummaryReportRowDto, period: Period): SorterReturnsSummaryReportRowDto {
    const r = new SorterReturnsSummaryReportRowDto();
    r.count = d.count;
    r.deviceName = d.deviceName;
    r.periodDisplay = formatPeriodDisplay(d.periodStart, period);
    return r;
}

function formatPeriodDisplay(periodStart: string, period: Period): string {
    const m = moment(periodStart);
    switch (period) {
        case Period.Hourly:
            return m.format('YYYY-MM-DD h:mm a');
        case Period.Daily:
            return m.format('YYYY-MM-DD');
        case Period.Monthly:
            return m.format('YYYY-MM');
        case Period.Yearly:
            return m.format('YYYY');
    }
}

export const returnsSummaryReport: ReportConfig = {
    id: 'sorter-returns-summary',
    label: 'Returns Summary',
    category: 'Sorter',
    usesPeriod: true,
    showHeader: true,
    columns: [
        { key: 'periodDisplay', label: 'Period',      width: '20%'  },
        { key: 'deviceName',    label: 'Device Name', width: '60%'  },
        { key: 'count',         label: 'Count',       width: '20%', align: 'right'  },
    ],
    endpoint: 'sorter-returns-summary-report',
    mapRows: (rows, search) => rows.map(d => toRecord(d, search.groupBy as Period)),
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/reports/definitions/sorter/returns-summary.report.ts